import { render, staticRenderFns } from "./edit-investment-round.vue?vue&type=template&id=763d6e92&scoped=true"
import script from "./edit-investment-round.vue?vue&type=script&lang=js"
export * from "./edit-investment-round.vue?vue&type=script&lang=js"
import style0 from "./edit-investment-round.vue?vue&type=style&index=0&id=763d6e92&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "763d6e92",
  null
  
)

export default component.exports